// extracted by mini-css-extract-plugin
export default {"TestimonialsMain":"Testimonials_TestimonialsMain__klNg5","carouselConatiner":"Testimonials_carouselConatiner__ByvB6"};